import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { toastr } from 'react-redux-toastr';

import copyStringToClipboard from '../../../../util/copyStringToClipboard';
import InputForm from './InputForm';

import './styles.scss';

const environment = process.env.REACT_APP_ENVIRONMENT?.toLocaleLowerCase();

const getBaseUrl = (environmentName) => {
  const environmentNames = {
    test: 'https://wapp.hmlbots.digitalcontact.cloud',
    prod: 'https://wapp.boteria.com.br',
    default: '',
  };

  return environmentNames[environmentName] || environmentNames.default;
};

const environmentLowerCase = environment?.toLocaleLowerCase();
const baseUrl = getBaseUrl(environmentLowerCase);

const URL_MESSAGE_CALLBACK = `${baseUrl}/whatsapp/wavy/message`;
const URL_STATUS_CALLBACK = `${baseUrl}/whatsapp/wavy/status`;

function ChannelWhatsAppWavySettings({ botId, wavySettings, user, onChange }) {
  const [showToken, setShowToken] = useState(false);

  const urlMessageCallback = `${URL_MESSAGE_CALLBACK}/${botId}`;
  const urlStatusCallback = `${URL_STATUS_CALLBACK}/${botId}`;

  function handleCopyUrlToClipboard(str) {
    copyStringToClipboard(str);
    toastr.success('Copiada', 'URL copiada com sucesso');
  }

  return (
    <>
      <div className="channel-whatsapp__wavy-settings__url-container">
        <p>URLs de callback (webhook a ser solicitado ao broker)</p>
        <p className="mb-2">
          <span>Mensagem:</span> <br />
          {urlMessageCallback}
          <img
            alt="Copy icon"
            src="/assets/images/icons/icon_copiar.svg"
            onClick={() => handleCopyUrlToClipboard(urlMessageCallback)}
          />
        </p>
        <p>
          <span>Status:</span> <br />
          {urlStatusCallback}
          <img
            alt="Copy icon"
            src="/assets/images/icons/icon_copiar.svg"
            onClick={() => handleCopyUrlToClipboard(urlStatusCallback)}
          />
        </p>
      </div>

      <InputForm
        disabled={!!(user && user.selectedCompany?.claim?.name === 'Viewer')}
        id="number"
        name="number"
        label="Número"
        placeholder="5511999999999"
        value={wavySettings.number}
        onChange={onChange}
      />

      <InputForm
        disabled={!!(user && user.selectedCompany?.claim?.name === 'Viewer')}
        id="username"
        name="username"
        type="text"
        label="Usuário"
        placeholder="usuário do canal"
        value={wavySettings.username}
        onChange={onChange}
      />

      <InputForm
        disabled={!!(user && user.selectedCompany?.claim?.name === 'Viewer')}
        id="authenticationToken"
        name="authenticationToken"
        type={showToken ? 'text' : 'password'}
        label="Token de autenticação"
        placeholder="********"
        value={wavySettings.authenticationToken}
        onChange={onChange}
        toggleShowPassword={() => setShowToken(!showToken)}
        showPassword={showToken}
      />
    </>
  );
}

ChannelWhatsAppWavySettings.propTypes = {
  botId: PropTypes.string.isRequired,
  wavySettings: PropTypes.shape({
    username: PropTypes.string,
    authenticationToken: PropTypes.string,
  }).isRequired,
  user: PropTypes.shape({
    claim: PropTypes.shape({
      name: PropTypes.string,
    }),
  }).isRequired,
  onChange: PropTypes.func.isRequired,
};

export default ChannelWhatsAppWavySettings;
